import { TitleOwnerIncomeType } from '@graphql/index';

// Shared income-type vocabulary for the land-title income flow. The declared
// income type (chosen in DeclareTaxableIncome) drives which verification UI the
// owner sees in VerifyDeclaredIncome:
//   EMPLOYED / SELF_EMPLOYED → Notice of Assessment upload
//   RETIREE (self-funded)    → Superannuation statement OR Notice of Assessment
//   PENSIONER                → Pensioner Concession Card OR Notice of Assessment
//   NO_INCOME                → $0 declaration (skip)
// Sourced from the backend TitleOwnerIncomeType enum so FE values can never
// drift from the GraphQL schema — no FE↔BE translation is needed.
export const INCOME_TYPES = TitleOwnerIncomeType;

export type IncomeType = TitleOwnerIncomeType;

export const INCOME_TYPE_OPTIONS: Array<{ label: string; value: IncomeType }> = [
  { label: 'Employed', value: TitleOwnerIncomeType.EMPLOYED },
  { label: 'Self-Employed', value: TitleOwnerIncomeType.SELF_EMPLOYED },
  { label: 'Pensioner (Pension Concession Card holder)', value: TitleOwnerIncomeType.PENSIONER },
  { label: 'Retiree (Self-funded)', value: TitleOwnerIncomeType.RETIREE },
  { label: 'No income', value: TitleOwnerIncomeType.NO_INCOME },
];
